module.exports = __webpack_public_path__ + "img/logo@2x.fca251b7.png";